import { SVGProps } from "react"

const BigEyeIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="70" height="70" rx="10" fill="#BBFB35"/>
		<path d="M35.584 21.2089C24.8614 20.9291 16.0228 27.306 12.2273 35.5807C16.5028 43.4302 24.4818 48.8503 34.7081 48.9363C45.0816 49.0236 51.7051 43.8252 57.6269 35.5807C52.3716 27.7415 45.8739 21.4773 35.584 21.2089Z" fill="white" />
		<path d="M35.584 21.2089C24.8614 20.9291 16.0228 27.306 12.2273 35.5807C16.5028 43.4302 24.4818 48.8503 34.7081 48.9363C45.0816 49.0236 51.7051 43.8252 57.6269 35.5807C52.3716 27.7415 45.8739 21.4773 35.584 21.2089Z" stroke="black" strokeWidth="3" />
		<ellipse cx="34.854" cy="35.1452" rx="12.4082" ry="12.3394" fill="#BBFB35" />
		<ellipse cx="34.8539" cy="35.1452" rx="5.10928" ry="5.08095" fill="#00030C" />
	</svg>
)

export default BigEyeIcon